import services from '../services'
import * as types from './mutation-types'

export const GetSetting = ({ commit }) => (
  services.setting().then(res => {
    commit(types.SET_SETTING, res.data.data)
  })
)

export const LoadOnceSetting = ({ state, dispatch }) => {
  if (isObjectEmpty(state.setting)) {
    dispatch('GetSetting')
  }
}

export const GetStatusList = ({ commit }, params) => (
  services.status(params).then(res => {
    commit(types.SET_STATUSLIST, res.data)
  })
)

export const GetRefStatusList = ({ commit }, params) => (
  services.refstatus(params).then(res => {
    commit(types.SET_REFSTATUSLIST, res.data)
  })
)

export const GetAttachmentType = ({ commit }, params) => (
  services.attachmentTypes(params).then(res => {
    commit(types.SET_ATTACHMENTTYPE, res.data)
  })
)

export const GetStatusSelect = ({ commit }, params) => (
  services.statusSelect(params).then(res => {
    commit(types.SET_STATUSSELECT, res.data)
  })
)

export const SaveSettingIntegration = async ({ commit }, obj) => {
  await services.saveIntegration(obj).then(res => {
    commit(types.SET_SETTING, res.data.data)
    return res
  })
}

export const SaveSetting = async ({ commit }, obj) => {
  await services.saveSetting(obj).then(res => {
    commit(types.SET_SETTING, res.data.data)
    return res
  })
}

function isObjectEmpty (o) {
  if (typeof o === 'object') {
    return Object.values(o).length === 0
  }
  return true
}
